var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreaSelector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#ec1377;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-462 -1030)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(462 1030)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(404.005 1034.008)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.993,0A6,6,0,0,0,64,5.993c0,4.154,5.41,9.612,5.64,9.843a.5.5,0,0,0,.71,0c.23-.231,5.64-5.689,5.64-9.843a6,6,0,0,0-6-5.993Zm0,14.76C68.8,13.483,65,9.166,65,5.993a4.994,4.994,0,0,1,9.989,0C74.987,9.164,71.186,13.483,69.993,14.76Z",
    transform: "translate(-64 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.997 2.997)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M163,96a3,3,0,1,0,3,3A3,3,0,0,0,163,96Zm0,4.994a2,2,0,1,1,2-2,2,2,0,0,1-2,2Z",
    transform: "translate(-160 -96)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaSelector);
export default __webpack_public_path__ + "static/media/area-selector.209fb7b2f0613faa21dce08019cd5d8a.svg";
export { ForwardRef as ReactComponent };